///这是日语-语法-每一个语法项目的组件

import { forwardRef, useImperativeHandle, useState } from "react";
import { Button, TextArea } from "antd-mobile";

import styles from "./GrammaList.module.css"
import "./Adm.css"

const colors = [{ 'backgroundColor': '#daeaf9' }, { 'backgroundColor': '#f9e7daff' }]
var _firstInit = true
//props.order     当前item的顺序
//props.item  当前的gramma信息
//props.disp  当前的显示模式 fix / gramma / main / def / all
//props.disp  当前的显示模式 word / kana / def / all


export default forwardRef((props, ref) => {
  // console.log('-----一条word项目----', props.order, props.item)
  var c = Number(props.order) % 2
  // var c = Math.random() < 0.5 ? 0 : 1

  var disp = props.disp

  var dfTop = true, dfWord = true, dfDef = true
  switch (disp) {
    case 'word':
      dfDef = false
      dfTop = false
      break;
    case 'kana':
      if (props.item.kana && props.item.kana !== '') dfWord = false
      dfDef = false
      break;
    case 'definition':
      dfTop = false
      dfWord = false
      break;
    case 'all':
      break;
    default:
      break;
  }

  const [disTop, setDisLeft] = useState(dfTop)
  const [disWord, setDisGramma] = useState(dfWord)
  const [disDef, setDisDef] = useState(dfDef)
  const [trig, setTrig] = useState(0)
  if (_firstInit) {

    if (disTop !== dfTop) setDisLeft(dfTop)
    if (disWord !== dfWord) setDisGramma(dfWord)
    if (disDef !== dfDef) setDisDef(dfDef)

    _firstInit = false
  }
  const refresh = () => {
    setTrig(trig + 1)
  }
  const refreshAfterEdit = () => {

  }
  useImperativeHandle(ref, () => ({
    refresh,
    refreshAfterEdit,
  }))

  return (<div trig={trig} className={styles.listWordContent} style={colors[c]}>
    <div className={styles.lefter} >
      {props.item.kana ?
        <Button onMouseDown={() => setDisLeft(!disTop)}
          style={disTop ? {} : { 'color': 'white' }}
          className={styles.btnTop}>
          {props.item.kana}
        </Button> : ''}
      <Button onMouseDown={() => setDisGramma(!disWord)}
        className={styles.btnWord}
        style={disWord ? {} : { 'color': 'white' }}>
        {props.item.word}
      </Button>
    </div>
    <div className={styles.righter}>
      <Button onMouseDown={() => setDisDef(!disDef)}
        style={disDef ? {} : { 'color': 'white' }}
        className={styles.btnRighter}>
        <div style={{
          whiteSpace: 'pre-wrap',   // 保留换行符和空格
          fontSize: '14px',
        }}>{props.item.definition}</div>
      </Button>
    </div>
  </div>)
})